module.exports = __webpack_public_path__ + "img/icon-campanha-ativa.6ca887a9.svg";